/* src/app/components/cover-settings/cover-settings.component.scss */
.scrolled-container {
  overflow-y: scroll;
  height: 65vh;
  background-color: #37373e;
  border-radius: 10px;
  width: 100%;
}
.title {
  font-family: "Raleway", sans-serif;
  font-weight: 600;
  font-size: 22px;
  color: #949494;
}
.section {
  background: transparent;
  border-radius: 15px;
  padding: 15px;
}
.section .section_title,
.section ion-radio {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
}
.section .option {
  border-radius: 10px;
  border: 1px solid #949494;
  background: transparent;
}
.section .option.selected {
  background: rgba(67, 192, 246, 0.0509803922);
  border: 2px solid #43c0f6;
}
.section .paperWeight .paperWeight_title {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: white;
}
.section .paperWeight .paperWeight_subtitle {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #949494;
}
.section .coverOptions ion-radio {
  padding: 10px;
}
.section .coverOptions ion-radio::part(native) {
  border: 2px solid #ff5733;
}
.section .coverOptions .coverOption_title {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: white;
}
.section .coverOptions .default_annotation {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #949494;
}
.section .coverOptions .title_annotation {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 12px;
  padding: 5px 8px;
  border-radius: 20px;
}
.section .coverOptions .title_annotation.pink {
  color: #c80064;
  background-color: #ffd5eb;
}
.section .coverOptions .title_annotation.yellow {
  color: #d59b00;
  background-color: #fff0c6;
}
.section .coverOptions .coverOption_subtitle {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #949494;
  white-space: pre-wrap;
}
.coverTypeIcon {
  height: 75px;
  width: 72px;
}
ion-button {
  border-radius: 10px;
  border-width: 1px;
}
.tooltip-icon {
  width: 24px;
  position: absolute;
  top: 0;
  right: 0;
}
.videoLink {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: var(--ion-color-primary);
  white-space: pre-wrap;
  cursor: pointer;
}
.videoLink:hover {
  color: rgba(37, 157, 255, 0.6);
}
/*# sourceMappingURL=cover-settings.component-TAI4IPFX.css.map */
